import { env as ENV } from '@hb/hbridge';
import { env as newEnv } from '@hb/bridge-core';
import { getParams } from '@/utils/utils';
import pkg from '../../package.json';

const APP_VERSION = pkg.version;

// 通过 UA 判断是否为鸿蒙系统（OpenHarmony + ArkWeb 内核）
const isHarmonyOS =
  /OpenHarmony/i.test(navigator.userAgent) ||
  /ArkWeb/i.test(navigator.userAgent);

let osSystemCode = 63; // H5所在环境的systemCode ，默认 63，浏览器环境
let systemCode = '';
let greenPlatformCode; // 绿色通道特殊处理的code,原因为：目前服务端只有针对支付宝webview的code 3，而没有针对小程序webview的code 9
if (ENV.isEasyBikeApp && ENV.isIOS) {
  osSystemCode = 61;
  greenPlatformCode = 4;
} else if (ENV.isEasyBikeApp && ENV.isAndroid) {
  osSystemCode = 62;
  greenPlatformCode = 4;
} else if (ENV.isAliMP || ENV.isAliMPMonitor) {
  osSystemCode = 65;
  greenPlatformCode = 3;
} else if (newEnv.isWxMP()) {
  osSystemCode = 64;
} else {
  const sysCode = getParams(window.location.href).systemCode;
  // 鸿蒙环境兜底：当 URL 未传 systemCode 时，通过 UA 识别鸿蒙并设置 68
  if (sysCode) {
    osSystemCode = sysCode;
    systemCode = sysCode;
  } else if (isHarmonyOS) {
    osSystemCode = 68;
    systemCode = '68';
  }
}

const env = {
  ...ENV,
  appVersion: APP_VERSION,
  isWxMP: newEnv.isWxMP(),
  isHarmonyOS,
  codeEnv: 'fat',
  cdnEnv: '',
  osSystemCode,
  // 当前osSystemCode只能设置成number且字段名与端内不太一致
  systemCode: String(systemCode) || String(osSystemCode),
  greenPlatformCode,
};

env.codeEnv = process.env.REACT_APP_ENV || 'fat';
if (env.codeEnv === 'test') {
  env.codeEnv = 'dev';
}
env.cdnEnv = env.codeEnv === 'pro' ? '' : `${env.codeEnv}/`;

export default env;
